export class AccountSearch {
    number: string;
    pbxId: number;
    personId: number;
    excludeId: number;
}
